// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from './Modal';
import { toast } from 'react-toastify';

export default class CreateStack extends Modal {

    state = {
        name: "",
        alert: false
    }

    createFromScratch = async () => {
        const name = this.state.name;

        if (!name || name === "")
            return this.alert();

        await this.setState({ name: "" });
        await this.props.modal();
        await this.props.createStackExec(name, this.props.data ? this.props.data.path : null);
    }

    loadPretrainedModel = async () => {
        const name = this.state.name;
        await this.setState({ name: "" });
        this.props.modal("pretrained-model", {
            name,
            root: this.props.data ? this.props.data.path : null
        });
    }

    loadWorkflowTemplate = async () => {
        const name = this.state.name;
        await this.setState({ name: "" });
        if(!name) {
            toast.error("Please add name of stack being created.")
            return;
        }
        this.props.modal("workflowTemplate-model", {
            name,
            root: this.props.data ? this.props.data.path : null
        });
    }

    renderContent = () => {
        return (<div className="modal-content modal-center">
            
            <h1>Create a new stack!</h1>

            {/* Disable for now */}
            {false && this.props.data && this.props.data._id && <p>
                You are creating a new stack within: <strong>{this.props.data.path}</strong>
            </p>}

            <h2>What's your new stack called?</h2>

            <input
                id="stack"
                name="stack"
                type="text"
                className={this.state.alert ? "input-error" : ""}
                placeholder="Enter stack name..."
                style={{ width: 300 }}
                value={this.state.name}
                onClick={e => e.stopPropagation()}
                onChange={e => this.setState({ name: e.target.value.replace(/\//g, ""), alert: false })}
            />

            <p>
                <i>Don't know what stacks you need?</i><br />
                Try a <strong>template</strong> to quickly get your workflow set up!
            </p>

            <h2>And now, pick an option...</h2>
            <div
                className="modal-create-option"
                onClick={this.createFromScratch}
            >
                <div className="flipper">
                    <div className="modal-create-option-front">
                        <img
                            src="https://static.stax.ai/images/graphics/create-from-scratch.png"
                            alt="Graphic"
                        />
                        <h2>Create from <u>scratch</u></h2>
                    </div>
                    <div className="modal-create-option-back">
                        <h2>Create from <u>scratch</u></h2>
                        <p>
                            You will need to upload 5 to 10 similar example documents for your bots to learn from. They will use these to train a completely custom model for you!
                        </p>
                    </div>
                </div>
            </div>
            <div
                className="modal-create-option"
                style={{ marginLeft: 40 }}
                onClick={this.loadWorkflowTemplate}
            >
                <div className="flipper">
                    <div className="modal-create-option-front">
                        <img
                            src="https://static.stax.ai/images/graphics/load-pretrained-model.png"
                            alt="Graphic"
                        />
                        <h2>Load a <u>template</u></h2>
                    </div>
                    <div className="modal-create-option-back">
                        <h2>Load a <u>template</u></h2>
                        <p>
                            This is the easiest way to set up your workflow! Pick a template that is similar to what you're looking for and go from there.                             
                        </p>
                    </div>
                </div>
            </div>
            
        </div>);
    }

};